import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SetOptions,
} from '@angular/fire/firestore';
import {
  ProfileAngularAppModel,
  ProfileAngularAppSchema,
  ProfileAngularDbModel,
  ProfileAngularDbSchema,
} from '@padspin/models-angular';

export class ProfileAngularConverter implements FirestoreDataConverter<
  ProfileAngularAppModel,
  ProfileAngularDbModel
> {
  toFirestore(o: ProfileAngularAppModel): ProfileAngularDbModel;
  toFirestore(
    o: Partial<ProfileAngularAppModel>,
    options: { merge: true },
  ): Partial<ProfileAngularDbModel>;
  toFirestore(
    o: ProfileAngularAppModel | Partial<ProfileAngularAppModel>,
    options?: SetOptions,
  ): ProfileAngularDbModel | Partial<ProfileAngularDbModel> {
    if (options && 'merge' in options && options.merge) {
      // Merge mode: allow partial input
      const parsedPartialApp = ProfileAngularAppSchema.partial().parse(o);
      const parsedPartialDB =
        ProfileAngularDbSchema.partial().parse(parsedPartialApp);
      return parsedPartialDB as Partial<ProfileAngularDbModel>;
    }
    // Full object mode: require all fields and apply defaults
    const parsedFullApp = ProfileAngularAppSchema.parse(o);
    return ProfileAngularDbSchema.parse(parsedFullApp);
  }
  fromFirestore(
    snapshot: QueryDocumentSnapshot<
      ProfileAngularAppModel,
      ProfileAngularDbModel
    >,
  ): ProfileAngularAppModel {
    const parsed = ProfileAngularDbSchema.parse(snapshot.data());
    return ProfileAngularAppSchema.parse(parsed);
  }
}
